<div class="login-dialog">
  <si-generic-dialog [(displayDialog)]="displayDialog"
                     button1Text="SI_LOG_IN"
                     button1Class="si-button_main"
                     [button1Close]="false"
                     [button1Disabled]="requestLoginForm?.invalid"
                     (updateButton1Change)="onSubmit()"
                     (displayDialogChange)="onClickCloseDialog()">
    <div class="mt-3">{{'SI_LOGIN_TO_CONFIRM_APPOINTMENT' | translate}}</div>
    <si-generic-alert [showAlert]="errorText"
                      styleClass="error mt-4"
                      [text]="errorText"
      ></si-generic-alert>
    <div class="mt-3">
      <form #requestLoginForm="ngForm"
            id="requestLoginForm"
            name="requestLoginForm">
        <div>
          <div class="row">
            <div class="col-12">
              <si-input id="loginDialogEmail"
                        name="loginDialogEmail"
                        text="SI_EMAIL"
                        placeholder="SI_WRITE_HERE"
                        type="email"
                        [(model)]="model.username"
                        [siAutofillListener]="model"
                        siAutofillListenerProperty="username"
                        (keyEnterPress)="onSubmit()"
                        [autoFocus]="true"
                        rule="generic.emailNotNull"
              ></si-input>
            </div>
            <div class="col-12 mt-4">
              <si-input id="loginDialogPassword"
                        name="loginDialogPassword"
                        text="SI_PASSWORD"
                        placeholder="SI_WRITE_HERE"
                        type="password"
                        [(model)]="model.password"
                        [siAutofillListener]="model"
                        siAutofillListenerProperty="password"
                        (keyEnterPress)="onSubmit()"
                        tooltipIcon="icosun-help_circle font-color-main3-dark"
                        [tooltipText]="tooltipTextPasswordPolicies"
                        tooltipPosition="right"
                        [tooltipEscape]="false"
                        rule="generic.fieldNotNull"
              ></si-input>
            </div>
          </div>
        </div>
      </form>
    </div>
  </si-generic-dialog>
</div>

<ng-container *ngIf="displayResendVerifyEmailDialog">
  <si-generic-dialog [(displayDialog)]="displayResendVerifyEmailDialog"
                    dialogTitle="SI_RESEND_VERIFY_EMAIL_TITLE"
                    dialogText="SI_RESEND_VERIFY_EMAIL_INFO"
                    button1Text="SI_ACCEPT"
                    button1Class="si-button_main"
                    button2Text="SI_CANCEL"
                    button2Class="si-button_secondary"
                    [closable]="false"
                    (updateButton1Change)="onClickButtonResendVerifyEmailDialog(true)"
                    (updateButton2Change)="onClickButtonResendVerifyEmailDialog(false)">
  </si-generic-dialog>
</ng-container>

<ng-container *ngIf="displayEmailVerificationDialog">
  <si-email-verification-dialog [(displayDialog)]="displayEmailVerificationDialog"
                                (displayDialogChange)="onChangeDisplayVerificationDialog($event)"
                                [emailValue]="model.username"
                                [(emailVerificationCode)]="model.code"
                                (emailVerificationCodeChange)="onChangeVerificationCode()"
                                [emailVerificationErrorText]="verificationErrorText"
  ></si-email-verification-dialog>
</ng-container>

<ng-container *ngIf="displaySMSVerificationDialog">
  <si-sms-verification-dialog [(displayDialog)]="displaySMSVerificationDialog"
                              (displayDialogChange)="onChangeDisplayVerificationDialog($event)"
                              [phoneValue]="phoneValue"
                              [(smsVerificationCode)]="model.code"
                              (smsVerificationCodeChange)="onChangeVerificationCode()"
                              [smsVerificationErrorText]="verificationErrorText"
  ></si-sms-verification-dialog>
</ng-container>
